export default class AppConstants {
  // Environment variables
  static DEVICE_TYPE = process.env.VUE_APP_DEVICE_TYPE;
  static BASE_URL = process.env.BASE_URL;
  static API_URL = process.env.VUE_APP_API_URL;
  static API_USERS_BASE_URL = process.env.VUE_APP_USERS_BASE_URL;

  // Common routers
  static LOGIN_ROUTER_PATH = '/login';
  static LOGIN_API_URL = '/loginByEmployee';
  static PATH_TO_TOP_PAGE = '/top';
  static PATH_TOP_FUJI = 'fuji';
  static PATH_TO_SETTING_PAGE = '/setting';
  static PATH_TO_MODE_SELECTION_PAGE_T_SORT = 'parallel-sorting';
  static PATH_TO_TOP_3D_SORTER = 'three-d-sorter';

  // Error codes and messages
  static RESPONSE_401_ERROR_CODE = 401;
  static RESPONSE_401_ERROR_MSG = 'Request failed with status code 401';
  static RESPONSE_500_ERROR_CODE = 500;
  static RESPONSE_500_ERROR_MSG = 'Request failed with status code 500';
  static RESPONSE_502_ERROR_CODE = 502;
  static RESPONSE_502_ERROR_MSG = 'Request failed with status code 502';
  static RESPONSE_504_ERROR_CODE = 504;
  static RESPONSE_504_ERROR_MSG = 'Request failed with status code 504';
  static RESPONSE_403_ERROR_MSG = 'Forbidden';

  // Storage names
  static STORAGE_TOKEN = 'plusa-token';
  static STORAGE_USER_DETAILS = 'plusa-user';
  static STORAGE_WORK_MODE = 'work-mode';

  // Work modes
  static WORK_MODE_T_SORT = 1;
  static WORK_MODE_T_SORT_3D = 2;
  static WORK_MODE_OPS = 3;
  static WORK_MODE_FULL_CHUTE = 4;
  static WORK_MODE_AMR = 5;

  // Sound file paths
  static ORDER_SOUND_SUCCESS_PATH = `${AppConstants.BASE_URL}sound/success.mp3`;
  static ORDER_SOUND_ERROR_PATH = `${AppConstants.BASE_URL}sound/error.mp3`;
  static ORDER_SOUND_WARNING_PATH = `${AppConstants.BASE_URL}sound/warning.mp3`;

  // Key codes
  static SPECIAL_SCAN_CHARACTER_KEYCODE_LIST = [
    109, // Numpad subtract
    189 // Minus hyphen
  ];

  // 商品スキャン
  static ROBOT_ACTION = 1;
  static GO_FLAG_ON_WARN = 0;
  static GO_FLAG_ON_WARN_AGV_COOPERATION = 1;
  static GO_FLAG_ON_WARN_AGV_COOPERATION_CONFIRM = 0;
  static INPUT_QTY = 1;
  static CHUTE_MODE = 0;
  static TASK_TYPE = 50;
  static TASK_TYPE_AGV = 51;

  static WORK_TYPE_THREE_DIMENSIONAL = 4;
  static WORK_TYPE_AGV_THREE_DIMENSIONAL = 5;

  /** バックエンドを呼び出すための3DSortの関数ID*/
  static FUNCTION_ID_3D_SORT = 'NormalThreeDimensionalSort';
  static FUNCTION_ID_AGV_COOPERATION = 'AgvThreeDimensionalSort';
  static FULL_FLAG = 0;
  static CHUTE_STATUS = 1;

  // Footer
  static FOOTER_NO_TASK_SORTING = 'NO_TASK_SORTING';
  static FOOTER_HAND_SORTING = 'HAND_SORTING';
  static FOOTER_MULTI_SORTING = 'MULTI_SORTING';
  static FOOTER_SINGLE_SORTING = 'SINGLE_SORTING';

  // ページ名
  static NAME_SETTING_PAGE = 'Setting';
  static NAME_MODE_SELECTION_PAGE = 'Model Selection';
  static NAME_HAND_SORTING_PAGE = 'Hand Sorting';
  static NAME_SINGLE_SORTING_PAGE = 'Single Sorting';
  static NAME_MULTI_SORTING_PAGE = 'Multi Sorting';
  static NAME_NO_TASK_SINGLE_SORTING_PAGE = 'No Task Single Sorting';
  static NAME_NO_TASK_MULTI_SORTING_PAGE = 'No Task Multi Sorting';
  static NAME_TOP_PAGE = 'TOP';
  static NAME_LOGIN_PAGE = 'login';
  static NAME_BREAK_INDUCTION_PAGE = 'Break Induction';

  // Scan Fields
  static SCAN_CODE_FIELD_ID = 'scanCode';

  // BreadCrumb Text
  static PRODUCT_SORTING_BREADCRUMB_TEXT = '商品仕分け';

  // Id modal
  static DETAIL_ERROR_MESSAGE_ID_MODAL = 'detail-error-message-id-modal';
  static SORTING_MODAL_ID = 'sortModal2';
  static WARNING_MESSAGE_MODAL_ID = 'warning-message-modal';

  // SCSS 変数と値
  static DEFAULT_VIEWPORT_WIDTH = 1280;
  static MIN_MAIN_VIEW_WIDTH = 900;
  // 成功/エラーメッセージのアニメーション時間 (秒)
  static ALERT_MESSAGE_ANIMATION_TIME = 0.3;
  static DEFAULT_MESSAGE_HEIGHT = 47;

  static MAIN_VIEW_WIDTH_VARIABLE_NAME = 'mainViewWidth';
  static ALERT_MESSAGE_ANIMATION_TIME_VARIABLE_NAME = 'alertMessageAnimationTime';
  static DEFAULT_VIEWPORT_WIDTH_VARIABLE_NAME = 'defaultViewportWidth';
  static DEFAULT_BROWSER_FONT_SIZE_VARIABLE_NAME = 'defaultBrowserFontSize';
  static DEFAULT_MESSAGE_HEIGHT_VARIABLE_NAME = 'defaultMessageHeight';
  // 入力数
  static QUANTITY_MAX_VALUE = 999;

  // 表示フラグ有効
  static DISPLAY_FLAG_ON = 1;

  // API設定定数
  static LINK_INDUCTION_DEVICE_URL = `/func/link-induction-device`;
  static GET_INDUCTION_STATUS_URL = `/func/get-induction-status`;
}
